import { render } from "./voice-call.vue?vue&type=template&id=1de93c9a"
import script from "./voice-call.vue?vue&type=script&lang=js"
export * from "./voice-call.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__